import React from "react";
import { useNavigate } from "react-router-dom";
import "./StudentNotificationList.css";
import { STUDENT_ROLE_CONFIG } from "./StudentRolesTab";
import { Button } from "react-bootstrap";

export const StudentNotificationList = ({
  notifications,
  loading,
  hasMore,
  onLoadMore,
  role
}) => {
  const navigate = useNavigate();
  
  const handleView = (notif) => {
    const baseRoute = STUDENT_ROLE_CONFIG[role]?.notification?.view; // use view
    if (!baseRoute) return; // safety
    navigate(`${baseRoute}/${notif.id}`);
  };
  return (
    <>
      <div className="notification-list-modern">
        {notifications
  ?.filter((notif) => notif !== null)
  .map((notif) => {
          // ✅ Correct read detection
          const isRead = !!notif.read_at;

          return (
            <div
              key={notif.id}
              className={`notification-card-modern ${
                isRead ? "read" : "unread"
              }`}
            >
              <div className="notification-left">
                {!isRead && <span className="unread-indicator"></span>}

                <div className="notification-content">
                  <h6
                    className={`notification-title ${
                      !isRead ? "fw-semibold" : ""
                    }`}
                  >
                    {notif.title}
                  </h6>

                  <p className="notification-desc">{notif.description}</p>

                  <span className="notification-time">
                    {new Date(notif.created_at).toLocaleString()}
                  </span>
                </div>
              </div>

              <div className="notification-action">
                <Button
                  onClick={() => handleView(notif)}
                  className="view-btn-modern"
                >
                  View
                </Button>
              </div>
            </div>
          );
        })}

        {!loading && notifications.length === 0 && (
          <div className="empty-state-modern">No notifications available.</div>
        )}
      </div>

      {hasMore && (
        <div className="text-center mt-4">
          <button
            className="load-more-btn-modern"
            onClick={onLoadMore}
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}
    </>
  );
};
